module.exports = __webpack_public_path__ + "static/media/biker.487a603c.jpg";